import React from 'react';
import {Switch} from '@headlessui/react';
import {useCurrentUserQuery, useUpdateClientUserMutation} from 'api';

export default () => {
  const [enabled, setEnabled] = React.useState(false);
  const {data: {currentUser: {clientUser = {}} = {}} = {}} =
    useCurrentUserQuery({});

  const [update] = useUpdateClientUserMutation();

  React.useEffect(() => {
    setEnabled(clientUser?.canReceiveDailyScoreChangeMail);
  }, [clientUser]);

  return (
    <div>
      <div className="flex justify-between items-center pb-3 border-b border-c-border">
        <div className="flex flex-col gap-1">
          <h3 className="text-foreground font-bold">顧客スコア変動状況</h3>
          <p className="text-foreground-light text-sm">
            前日の顧客スコア変動状況に関するメールを受け取ります。
          </p>
        </div>
        <Switch
          checked={enabled}
          onChange={(checked: boolean) => {
            update({
              variables: {
                id: clientUser?.id,
                attributes: {
                  canReceiveDailyScoreChangeMail: checked,
                },
              },
            });
            setEnabled(checked);
          }}
          className={`p-0 ${enabled ? 'bg-c-primary' : 'bg-c-bg'}
          relative inline-flex h-6 w-12 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}>
          <span
            aria-hidden="true"
            className={`${enabled ? 'translate-x-6' : 'translate-x-0'}
            pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
          />
        </Switch>
      </div>
    </div>
  );
};
